import React, { useState, useEffect } from 'react'
import { apiFetch } from '../services/api'
import AlertasVencimiento from '../components/AlertasVencimiento'

const PERIODOS = [
  { label: 'Hoy', value: 'hoy' },
  { label: 'Esta semana', value: 'semana' },
  { label: 'Este mes', value: 'mes' },
  { label: 'Este año', value: 'anio' },
  { label: 'Personalizado', value: 'custom' },
]

export default function Dashboard() {
  const [periodo, setPeriodo] = useState('hoy')
  const [loading, setLoading] = useState(true)

  const [data, setData] = useState({
    totalProductos: 0,
    ventasPeriodo: 0,
    ingresosTotales: 0,
    stockBajoAlerta: 0,
    ultimasVentas: []
  })

  useEffect(() => {
    setLoading(true)
    apiFetch(`/dashboard/resumen?periodo=${periodo}`)
      .then((resData) => {
        if (resData && !resData.detail) {
          setData(resData)
        }
      })
      .catch((err) => console.error("Error al obtener dashboard:", err))
      .finally(() => setLoading(false))
  }, [periodo])

  return (
    <div style={{ padding: '2rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <div>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#0f172a', margin: 0 }}>Dashboard</h2>
          <p style={{ color: '#64748b', fontSize: '0.875rem', marginTop: '0.25rem' }}>Resumen general de tu negocio</p>
        </div>

        <div style={{ display: 'flex', gap: '0.5rem', background: '#fff', padding: '0.25rem', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
          {PERIODOS.map((p) => (
            <button
              key={p.value}
              onClick={() => setPeriodo(p.value)}
              style={{
                padding: '0.5rem 0.75rem',
                borderRadius: '6px',
                border: 'none',
                fontSize: '0.875rem',
                fontWeight: '600',
                cursor: 'pointer',
                background: periodo === p.value ? '#2563eb' : 'transparent',
                color: periodo === p.value ? '#ffffff' : '#64748b',
                transition: 'all 0.2s'
              }}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div style={{ padding: '2rem 0', color: '#64748b' }}>Actualizando métricas...</div>
      ) : (
        <>
          <AlertasVencimiento />

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.25rem', marginBottom:'2rem' }}>
            <div style={{ background: '#fff', padding: '1.25rem', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
              <p style={{ color: '#64748b', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.25rem' }}>Total Productos</p>
              <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#0f172a', margin: '0.5rem 0' }}>{data.totalProductos}</h3>
              <p style={{ color: '#64748b', fontSize: '0.75rem', fontWeight: '500', margin: 0 }}>Activos en catálogo</p>
            </div>

            <div style={{ background: '#fff', padding: '1.25rem', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
              <p style={{ color: '#64748b', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.25rem' }}>Ventas del Período</p>
              <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#2563eb', margin: '0.5rem 0' }}>{data.ventasPeriodo}</h3>
              <p style={{ color: '#64748b', fontSize: '0.75rem', fontWeight: '500', margin: 0 }}>Transacciones realizadas</p>
            </div>

            <div style={{ background: '#fff', padding: '1.25rem', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
              <p style={{ color: '#64748b', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.25rem' }}>Ingresos Totales</p>
              <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#16a34a', margin: '0.5rem 0' }}>
                ${data.ingresosTotales.toLocaleString('es-CL')}
              </h3>
              <p style={{ color: '#64748b', fontSize: '0.75rem', fontWeight: '500', margin: 0 }}>En el período seleccionado</p>
            </div>

            <div style={{ background: '#fff', padding: '1.25rem', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
              <p style={{ color: '#64748b', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.25rem' }}>Stock Bajo Alerta</p>
              <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#dc2626', margin: '0.5rem 0' }}>{data.stockBajoAlerta}</h3>
              <p style={{ color: '#64748b', fontSize: '0.75rem', fontWeight: '500', margin: 0 }}>Requieren reabastecimiento</p>
            </div>
          </div>

          <div style={{ background: '#fff', padding: '1.5rem', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#0f172a', margin: 0 }}>Últimas Ventas</h3>
            </div>

            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.875rem' }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid #e2e8f0', color: '#64748b', background: '#f8fafc' }}>
                    <th style={{ padding: '0.75rem 1rem', fontWeight: '600' }}>N° Venta</th>
                    <th style={{ padding: '0.75rem 1rem', fontWeight: '600' }}>Fecha</th>
                    <th style={{ padding: '0.75rem 1rem', fontWeight: '600' }}>Sucursal</th>
                    <th style={{ padding: '0.75rem 1rem', fontWeight: '600' }}>Total</th>
                    <th style={{ padding: '0.75rem 1rem', fontWeight: '600' }}>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {data.ultimasVentas.length === 0 ? (
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center', padding: '3rem 1rem', color: '#64748b' }}>
                        <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🧾</div>
                        <p style={{ margin: 0, fontWeight: '500' }}>Aún no hay ventas registradas.</p>
                      </td>
                    </tr>
                  ) : (
                    data.ultimasVentas.map((venta, index) => (
                      <tr key={index} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '0.75rem 1rem', fontWeight: 'bold', color: '#2563eb' }}>{venta.numero}</td>
                        <td style={{ padding: '0.75rem 1rem', color: '#64748b' }}>{venta.fecha}</td>
                        <td style={{ padding: '0.75rem 1rem', color: '#334155' }}>{venta.sucursal}</td>
                        <td style={{ padding: '0.75rem 1rem', fontWeight: 'bold', color: '#0f172a' }}>
                          ${venta.total.toLocaleString('es-CL')}
                        </td>
                        <td style={{ padding: '0.75rem 1rem' }}>
                          <span style={{ 
                            background: '#dcfce7', 
                            color: '#15803d', 
                            padding: '0.25rem 0.5rem', borderRadius: '999px', fontWeight: '600', fontSize: '0.75rem' 
                          }}>
                            {venta.estado}
                          </span>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
